import UIIcon from 'UIComponents/icon/UIIcon';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CreateViewLink = ({
  handleCreateViewClick,
  hasCustomViewsAccess
}) => /*#__PURE__*/_jsx(UITooltip, {
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "svh-workspace-ui-lib.navigation-sidebar.createDisabled"
  }),
  disabled: hasCustomViewsAccess,
  children: /*#__PURE__*/_jsxs(UIButton, {
    use: "tertiary",
    onClick: handleCreateViewClick,
    disabled: !hasCustomViewsAccess,
    size: "small",
    className: "m-top-3",
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "add",
      size: "xxs"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "svh-workspace-ui-lib.navigation-sidebar.addViewsButton"
    })]
  })
});
CreateViewLink.displayName = 'CreateViewLink';
export default CreateViewLink;